import { useValidations } from "@sttedra_ui/framework";

const { required } = useValidations();

export default function () {
  return {
    items: [
      {
        field: "Password",
        label: "Contraseña",
        rules: { required },
        classObj: ["col-12 md:col-6"],
        properties: {
          toggleMask: true,
        },
        type: "password",
      },
      {
        field: "confirmPassword",
        label: "Confirmar contraseña",
        rules: { required },
        classObj: ["col-12 md:col-6"],
        properties: {
          toggleMask: true,
        },
        type: "password",
      },
    ],
  };
}
